var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 96,
    viewBox: "0 0 105 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1524_1186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.225388 86.974V32.6309L69.5696 47.8667V86.7478L0.225388 86.974Z",
    fill: "#075255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7541 54.6504H10.5123V74.8003H24.7541V54.6504Z",
    fill: "#15A9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1312 54.6504H42.8894V74.8003H57.1312V54.6504Z",
    fill: "#15A9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 90.4902H0V96.0006H105V90.4902Z",
    fill: "#15A9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7336 0H11.0451V9.99272H24.7336V0Z",
    fill: "#17AAAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5738 32.4872V14.0645H25.2049V35.5303L10.5738 32.4872Z",
    fill: "#15A9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.959 53.0488C104.959 51.116 104.939 49.43 104.939 47.3533C104.939 38.9644 97.7869 31.9941 88.9549 31.9941C80.1229 31.9941 72.8893 38.7793 72.8893 47.1683C72.8893 49.2449 72.8893 50.7459 72.8893 53.0488H104.959Z",
    fill: "#075255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5287 24.4492H83.5656V30.6998H94.5287V24.4492Z",
    fill: "#075255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 54.6719H72.9508V61.2926H105V54.6719Z",
    fill: "#075255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.939 62.7324H72.9508V87.7965H104.939V62.7324Z",
    fill: "#0E5356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.459 39.3942C42.377 37.2147 42.418 32.5268 42.418 30.4501C42.418 28.1884 42.4795 25.9472 43.2786 23.3771C46.5573 12.7675 56.1885 5.63281 67.2541 5.63281C77.2745 5.63281 88.1967 12.5002 91.045 22.5135H86.5573C83.2172 14.762 75.6352 9.74504 67.2541 9.74504C58.0123 9.74504 49.9385 15.7078 47.1926 24.5902C46.6188 26.4407 46.5164 28.0033 46.5164 30.4501C46.5164 32.5062 46.5164 38.14 46.5983 40.2578L42.459 39.3942Z",
    fill: "#15A9AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1524_1186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMill);
export default __webpack_public_path__ + "static/media/mill.0ae63d3515b6a7b7d0dee2770f883478.svg";
export { ForwardRef as ReactComponent };